// This is the Client-side UI Interface for the Contact/Personal Details screen, providing form validation.

const $ = App.common.jQuery

// Timeout after Submit in seconds
const SUBMIT_TIMEOUT = 15

const PasswordSetForm = require('common/models/form-password-set')
const FormValidation = require('client/js/helpers/form-validation')

class PasswordSetUI {
   // Init is called when the page first loads.
   static init() {
      let form = $('#password-set-form')

      FormValidation.init(form, PasswordSetForm, (err, result) => {
         let formdata = form.serializeObject()
         // console.log('Password Set validation', err, result, formdata)
         if (result) return; // Invalid!

         // Disable submit button for a bit to stop double-submits
         let subbtn = form.find('*[type="submit"]')
         subbtn.prop('disabled', true)
         setTimeout(()=> subbtn.prop('disabled', false), SUBMIT_TIMEOUT * 1000)

         // Really submit
         form.trigger('submit')
      })
   }
}

module.exports = PasswordSetUI
